export function getColorFromName(name = '') {
  const colors = [
    '#FF9AA2', '#FFB7B2', '#FFDAC1', '#E2F0CB',
    '#B5EAD7', '#C7CEEA', '#D5AAFF', '#A0CED9',
  ];
  const index = [...name].reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
  return colors[index];
}

export function getTextColorForBackground(hex) {
  const color = hex.replace('#', '');
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.6 ? '#000000' : '#FFFFFF';
}
